import styled from "styled-components"
import { mediaQuery } from "@zendeskgarden/react-theming"

export const H1 = styled.h1`
  margin-bottom: ${props => props.theme.space.md};
  color: ${props => props.theme.colors.document.headings};
  font-weight: ${props => props.theme.fontWeights.bold};
  font-size: ${props =>
    props.bigger ? props.theme.fontSizes.x5l : props.theme.fontSizes.x4l};
  line-height: ${props =>
    props.bigger ? props.theme.lineHeights.x5l : props.theme.lineHeights.x4l};

  ${props => mediaQuery("down", "sm", props.theme)} {
    font-size: ${props =>
      props.bigger ? props.theme.fontSizes.x4l : props.theme.fontSizes.xxxl};
    line-height: ${props =>
      props.bigger
        ? props.theme.lineHeights.x4l
        : props.theme.lineHeights.xxxl};
  }
`

export const H2 = styled.h2`
  margin-bottom: ${props => props.theme.space.md};
  color: ${props => props.theme.colors.document.headings};
  font-weight: ${props =>
    props.bigger
      ? props.theme.fontWeights.bold
      : props.theme.fontWeights.semibold};
  font-size: ${props =>
    props.bigger ? props.theme.fontSizes.x4l : props.theme.fontSizes.xxl};
  line-height: ${props =>
    props.bigger ? props.theme.lineHeights.x4l : props.theme.lineHeights.xxl};

  ${props => props.bigger && mediaQuery("down", "sm", props.theme)} {
    font-size: ${props => props.theme.fontSizes.xxxl};
    line-height: ${props => props.theme.lineHeights.xxxl};
  }
`

export const H3 = styled.h3`
  margin-bottom: ${props => props.theme.space.sm};
  color: ${props => props.theme.colors.document.headings};
  font-weight: ${props => props.theme.fontWeights.semibold};
  font-size: ${props => props.theme.fontSizes.xl};
  line-height: ${props => props.theme.lineHeights.xl};
`

export const Subheading = styled.div`
  margin-bottom: ${props => props.theme.space.lg};
  color: ${props => props.theme.colors.document.subheading};
  font-weight: ${props => props.theme.fontWeights.regular};
  font-size: ${props => props.theme.fontSizes.document.subheading};
  line-height: ${props => props.theme.lineHeights.lg};
  letter-spacing: ${props => props.theme.letterSpacing.subheading};
`

export const HorizontalRule = styled.hr`
  margin: ${props => props.theme.space.md} 0;
  border-color: ${props => props.theme.colors.document.horizontalRule};
`
